// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cce6","buttons":"styles_buttons__1-lT3"};